export { default } from "./DeleteProfile.page.js";
